import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Tab, Nav, Button, Dropdown, Modal, Card, ListGroup, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import ReactFsLightbox from "fslightbox-react";
import { TbFileUpload } from "react-icons/tb";
import { FaFile } from "react-icons/fa";
import swal from "sweetalert";
//img
import user1 from "../../../assets/images/user/users.png";
//scrollbar
import Scrollbar from "smooth-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIgConversations,
  getIgConversationByUser,
} from "../../../store/instagram/instagramThunk";
import { uploadFileToCloudinary } from "../../../store/Cloudinary/CloudinaryThunk";
import {
  facebooksendmessage,
  fetchFBConversations,
  getFBConversationByUser,
} from "../../../store/facebook/facebookThunk";
import EmojiPicker from "emoji-picker-react";
import {
  getConnectedWABAs,
  getConversationById,
  getConversationList,
  getTemplates,
  getTemplatesById,
  sendWpMessage,
  updateWpStatus,
} from "../../../store/whatsApp/wpThunks";

const Wpchat = () => {
  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);
  const [chats, setChats] = useState(null);
  const [Showimg, setShowimg] = useState(null);

  const inputFile = useRef(null);

  const [currentChatId, setCurrentChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [whatsappIds, setWhatsappId] = useState();

  const [whatsappPhoneid, setwhatsappPhoneid] = useState();
  const [messageNavbar, setMessageNavbar] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [expireTime, setExpireTime] = useState(null);
  const [currentName, setCurrentName] = useState(null);
  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });
    const [showquickreply, setShowQuickReply] = useState(false);
    const [filteredQuickReplies, setFilteredQuickReplies] = useState(null);
  const [isSwitchOn, setIsSwitchOn] = useState(messageNavbar?.autoChat);
  const [newMessage, setNewMessage] = useState("");

  const [templates, setTemplates] = useState([]); // Store all templates
  const [selectedTemplate, setSelectedTemplate] = useState(null); // Store the selected template
  const [templateData, setTemplateData] = useState("");
  const [payloadValues, setPayloadValues] = useState([]);
    const [faqs, setFaqs] = useState(null);
  
  console.log(templateData, "templateDatatemplateData");
  console.log(
    payloadValues,
    "payloadValuespayloadValuespayloadValuespayloadValues"
  );
  const FsLightbox = ReactFsLightbox.default
    ? ReactFsLightbox.default
    : ReactFsLightbox;
  let dispatch = useDispatch();
  const sectionRef = useRef(null);
  //   const { conversations, loading, conversationDetails, error,message} = useSelector(
  //     (state) => state.facebook
  //   );
    const { getQuickreplyLoding, getQuickreplyerrer, getQuickreplySuccess } =
      useSelector((state) => state.Quickreply);
      
        useEffect(() => {
          setFaqs(getQuickreplySuccess?.data);
        }, [getQuickreplySuccess]);
  const {
    conversations,
    currentConversation,
    conversationDetails,
    error,
    message,
    loading,
    usergetTemplatesFullfill,
    getTemplatesError,
    getTemplatesByIdFullfill,
    getTemplatesByIdError,
  } = useSelector((state) => state.whatsapp);
  const { uploadStatus, uploadedFile, uploadError } = useSelector(
    (state) => state.cloudinary
  );
  console.log(usergetTemplatesFullfill,"-----usergetTemplatesFullfill---------")
  useEffect(() => {
    dispatch(getConversationList());
    dispatch(getTemplates());
  }, []);

  const handlePayloadChange = (index, value) => {
    const updatedValues = [...payloadValues];
    updatedValues[index] = value;
    setPayloadValues(updatedValues);
  };
  // const getUpdatedText = () => {
  //   if (!selectedTemplate) return 'No Message Type Selected';

  //   const template = templates.find(t => t._id === selectedTemplate?._id);
  //   if (!template?.components?.[0]?.text) return 'No Message Type Selected';

  //   const textSegments = template.components[0].text.split(/({{\d+}})/g); // Split text by placeholders

  //   const updatedText = textSegments.map((segment, index) => {
  //     const match = segment.match(/{{(\d+)}}/); // Match placeholders
  //     if (match) {
  //       const key = parseInt(match[1], 10); // Extract the placeholder number

  //       if (key === 1) {
  //         // For {{1}}, show the value from payloadValues or currentName, and allow it to be updated from the input field
  //         const value = payloadValues[key] || currentName;
  //         return (
  //           <span
  //             key={index}
  //             style={{ fontWeight: 'bold' }}
  //           >
  //             {value}
  //           </span>
  //         );
  //       }

  //       // For other placeholders, use payloadValues and wrap them in <strong> for bold formatting
  //       const value = payloadValues[key] || segment;
  //       return <strong key={index}>{value}</strong>; // Apply bold styling for other placeholders
  //     }

  //     return segment; // Return plain text for non-placeholder segments
  //   });

  //   return updatedText; // Return JSX elements
  // };

  const getUpdatedText = () => {
    if (!selectedTemplate) return "No Message Type Selected";

    const template = templates.find((t) => t._id === selectedTemplate?._id);
    if (!template?.components) return "No Message Type Selected";

    const updatedComponents = template.components.map(
      (component, compIndex) => {
        const textSegments = component.text?.split(/({{\d+}})/g) || []; // Split text by placeholders

        return textSegments.map((segment, index) => {
          const match = segment.match(/{{(\d+)}}/); // Match placeholders
          if (match) {
            const key = parseInt(match[1], 10); // Extract the placeholder number

            // Use payloadValues and default to currentName for {{1}} if applicable
            const value =
              key === 1
                ? payloadValues[key] || currentName
                : payloadValues[key] || "";
            return <strong key={`${compIndex}-${index}`}>{value}</strong>;
          }
          return segment; // Return plain text for non-placeholder segments
        });
      }
    );

    // Flatten and return the updated components
    return updatedComponents.flat();
  };

  const fetchTemplateData = (templateId) => {
    dispatch(getTemplatesById(templateId));
    setTemplateData(getTemplatesByIdFullfill?.template);
    setTemplates(usergetTemplatesFullfill?.template);
  };

  console.log(
    selectedTemplate,
    "selectedTemplateselectedTemplateselectedTemplateselectedTemplateselectedTemplate"
  );
  useEffect(() => {
    if (usergetTemplatesFullfill?.template?.length) {

      setTemplates(usergetTemplatesFullfill?.template);
      setSelectedTemplate(usergetTemplatesFullfill?.template[0]);
      fetchTemplateData(usergetTemplatesFullfill?.template[0]?._id);
    }
  }, [usergetTemplatesFullfill]);

  const handleTemplateChange = async (event) => {
    const templateId = event.target.value;
    const selectedTemplate = templates.find(
      (template) => template._id === templateId
    );
    setSelectedTemplate(selectedTemplate);
    if (selectedTemplate) {
      await fetchTemplateData(selectedTemplate._id);
    }
  };

  useEffect(() => {
    const socket = new WebSocket("ws://localhost:8080");

    // Listen for messages
    socket.onmessage = (event) => {
      console.log(event, "eventeventevent");
      const data = JSON.parse(event.data);
      console.log("Message received:", data);
      console.log(data.senderId, whatsappIds, "data.senderIddata.senderId");
      console.log(data.recipient, "data.recipientdata.recipientdata.recipient");
      if (data.type === "userList" && data.user) {
        setChats((prevUserList) =>
          prevUserList ? [data.user, ...prevUserList] : data.user
        );
      }
      if (data.type === "AlluserList" && data.getConversation) {
        // Ensure that chats is initialized and add the new user to the beginning of the array
        // chats = ;
        // setChats([data.user, ...chats])
        setChats(data.getConversation);
      }
      if (data.senderId === whatsappIds || data.recipient === whatsappIds) {
        console.log(
          messages,
          "messagesmessagesmessagesmessagesmessagesmessages+++++++++++++++++++++++++++++++++"
        );

        // Add the new message to the messages state

        setMessages((prevMessages) => {
          return prevMessages ? [...prevMessages, data] : [data];
        });
      }
    };

    // Handle WebSocket connection open
    // socket.onopen = () => {
    //     console.log('WebSocket connection established');
    // };

    // Handle WebSocket connection close
    socket.onclose = () => {
      console.log("WebSocket connection closed");
    };

    // Cleanup on component unmount
    return () => {
      socket.close();
    };
  }, [whatsappIds]);

  useEffect(() => {
    if (currentChatId) {
      setChats(conversations);
    } else {
      setChats(conversations);
      setCurrentChatId(conversations[0]?._id);
      setwhatsappPhoneid(conversations[0]?.myPhId);
      dispatch(getConversationById(conversations[0]?._id));
      setMessageNavbar(conversations[0]);
      setWhatsappId(conversations[0]?.whatsappId);
      setExpireTime(conversations[0]?.expireTime);
      setCurrentName(conversations[0]?.name);
      setTemplateData(getTemplatesByIdFullfill?.template);
    }
  }, [conversations]);

  useEffect(() => {
    dispatch(getConversationById(currentChatId));
  }, [currentChatId]);

  useEffect(() => {
    setMessages(currentConversation?.messages);
    setIsSwitchOn(currentConversation?.autoChat);
  }, [currentConversation]);

  useEffect(() => {
    console.log(
      uploadedFile,
      "----------------uploadedFiletype-------------------"
    );
    if (uploadedFile && uploadedFile.url) {
      // const data = {
      //   recipient: { id: senderId },
      //   message: {
      //     attachment: {
      //       type: "image",
      //       payload: {
      //         url: uploadedFile.url,
      //         is_reusable: true,
      //       },
      //     },
      //   },
      // };
      let fileType = uploadedFile?.filetype;
      let documentUrl = uploadedFile?.url;

      // dispatch(facebooksendmessage(data))
      if (fileType.startsWith("image/")) {
        console.log(fileType, "fileType imagwe ");
        const messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "image",
          image: {
            link: uploadedFile.url,
          },
        };
        dispatch(sendWpMessage(messageData));
      } else if (fileType.startsWith("application/")) {
        const messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "document",
          document: {
            link: uploadedFile.url,
          },
        };
        dispatch(sendWpMessage(messageData));
      } else if (fileType.startsWith("video/")) {
        const messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "video",
          video: {
            link: uploadedFile.url,
          },
        };
        dispatch(sendWpMessage(messageData));
      } else {
        alert("not support");
        console.log("Unsupported file type:", fileType);
      }
    }
  }, [uploadedFile]);
  useEffect(() => {
    if (sectionRef.current) {
      sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);
    }
  }, [messages, currentChatId]);
  let handleCopy = (message) => {
    navigator.clipboard.writeText(message);
  };
  const minisidebar = () => {
    const sidebar = document.getElementById("chatsidebar");
    if (sidebar) {
      sidebar.classList.toggle("sidebar-mini2");
    } else {
      console.error("Element with id 'sidebar' not found");
    }
  };
  const handleDocumentClick = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url || "file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleChatSelect = (item) => {
    dispatch(getConversationById(item?._id));
    setMessageNavbar(item);
    setWhatsappId(item.whatsappId);
    setwhatsappPhoneid(item?.myPhId);
    setCurrentChatId(item?._id);
    setCurrentName(item.name);
    setShowQuickReply(false);

    setExpireTime(item.expireTime);
    // setIsSwitchOn(item?.autochat);
  };
  let handleQuickReplies = (payload) => {
    if (payload) {
      setNewMessage(payload);
      setShowQuickReply(false);
    }
  };
  // const handleSendMessage = async () => {
  //   console.log(newMessage, "newMessage");
  //   console.log(whatsappIds, "-----------------whatsappIds-----------");
  //   try {
  //     let messageData = null;
  //     if (isExpired) {
  //       alert(currentName, "currentNamecurrentName");
  //       swal({
  //         title: "Sending Message...",
  //         text: "Please wait while your message is being sent.",
  //         allowOutsideClick: false,
  //         didOpen: () => {
  //           swal.showLoading();
  //         },
  //       });
  //       messageData = {
  //         messaging_product: 'whatsapp',
  //         to: whatsappIds,
  //         type: "template",
  //         template: {
  //           name: selectedTemplate?.templateName,
  //           language: {
  //             code: "en_US"
  //           },
  //           components: [
  //             {
  //               type: "body",
  //               parameters: [
  //                 {
  //                   type: "text",
  //                   text: currentName
  //                 },
  //                 {
  //                   type: "text",
  //                   text: " "
  //                 }
  //               ]
  //             }
  //           ]
  //         }
  //       };
  //       setShow4(false);
  //       setTemplateData("");
  //     } else {
  //       messageData = {
  //         messaging_product: "whatsapp",
  //         to: whatsappIds,
  //         type: "text",
  //         text: {
  //           body: newMessage,
  //         },
  //       };
  //     }

  //     // Dispatch the message
  //     await dispatch(sendWpMessage(messageData));
  //     setNewMessage("");

  //     // Show success alert
  //     swal.fire({
  //       icon: "success",
  //       title: "Message Sent",
  //       text: "Your message has been sent successfully!",
  //     });
  //   } catch (error) {
  //     console.error("Error sending message:", error);

  //     // Show error alert
  //     swal.fire({
  //       icon: "error",
  //       title: "Message Failed",
  //       text: "Something went wrong while sending the message.",
  //     });
  //   }
  // };

  // const handleSendMessage = async () => {
  //   try {
  //     const template = templates.find(t => t._id === selectedTemplate?._id);
  //     let messageText = template?.components?.[0]?.text;

  //     // Replace placeholders with input values
  //     if (messageText) {
  //       messageText = messageText.replace(/{{\d+}}/g, (_, index) => payloadValues[index] || '');
  //     }

  //     const messageData = {
  //       messaging_product: 'whatsapp',
  //       to: whatsappIds,
  //       type: "template",
  //       template: {
  //         name: template?.templateName,
  //         language: {
  //           code: "en_US",
  //         },
  //         components: [
  //           {
  //             type: "body",
  //             parameters: payloadValues.map(value => ({
  //               type: "text",
  //               text: value,
  //             })),
  //           },
  //         ],
  //       },
  //     };

  //     await dispatch(sendWpMessage(messageData));
  //     swal.fire({
  //       icon: "success",
  //       title: "Message Sent",
  //       text: "Your message has been sent successfully!",
  //     });
  //     setPayloadValues([]);
  //     handleClose4();
  //   } catch (error) {
  //     console.error("Error sending message:", error);
  //   }
  // };

  // const handleSendMessage = async () => {
  //   if (!selectedTemplate || !templates) return;

  //   try {
  //     // Find the selected template
  //     const template = templates.find((t) => t._id === selectedTemplate?._id);
  //     if (!template?.components?.[0]?.text) {
  //       alert('No template or template text found');
  //       return;
  //     }

  //     // Replace placeholders with payload values
  //     const updatedText = template.components[0].text.replace(/{{(\d+)}}/g, (match, key) => {
  //       const value = payloadValues[key]; // Get the value for the placeholder
  //       return value ? `<strong>${value}</strong>` : match; // Wrap the value in <strong> for bold formatting
  //     });

  //     // Create messageData based on the updated text
  //     const messageData = {
  //       messaging_product: "whatsapp",
  //       to: whatsappIds,
  //       type: "template",
  //       template: {
  //         name: template.templateName,
  //         language: {
  //           code: "en_US",
  //         },
  //         components: [
  //           {
  //             type: "body",
  //             parameters: Object.keys(payloadValues).map((key) => ({
  //               type: "text",
  //               text: payloadValues[key],
  //             })),
  //           },
  //         ],
  //       },
  //     };

  //     console.log("Message Data:", messageData);

  //     await dispatch(sendWpMessage(messageData));
  //     setNewMessage(""); // Reset the message field
  //     setPayloadValues({}); // Reset the payload values
  //     setShow4(false); // Close the modal
  //   } catch (error) {
  //     console.error("Error sending message:", error);
  //     alert("Failed to send the message. Please try again.");
  //   }
  // };

  // const handleSendMessage = async () => {
  //   if (!selectedTemplate) {
  //     console.error('No template selected.');
  //     return;
  //   }

  //   const template = templates.find(t => t._id === selectedTemplate?._id);
  //   if (!template?.components?.[0]?.text) {
  //     console.error('Template has no text.');
  //     return;
  //   }

  //   try {
  //     // Create a shallow copy of payloadValues to manipulate
  //     const payloadValuesToSend = { ...payloadValues };

  //     // Remove the first payload key if it matches the default currentName
  //     if (payloadValuesToSend[1] === currentName) {
  //       delete payloadValuesToSend[1];
  //     }

  //     // Construct the message by replacing placeholders with values
  //     const constructedMessage = template.components[0].text.replace(/{{(\d+)}}/g, (match, key) => {
  //       const index = parseInt(key, 10); // Extract the placeholder index
  //       if (index === 1) {
  //         // Use currentName if payloadValues for the first placeholder is not set
  //         return payloadValues[1] || currentName || match;
  //       }
  //       // For other placeholders, use payloadValues or keep the original placeholder
  //       return payloadValues[index] || match;
  //     });

  //     console.log('Constructed Message:', constructedMessage);

  //     // Prepare payload for the API
  //     const payload = {
  //       message: constructedMessage,
  //       templateId: selectedTemplate._id,
  //       payloadValues: payloadValuesToSend,
  //     };
  // console.log(payload ,"payloadpayload-----------------------------")
  //     // Send the message via API
  //     // const response = await axios.post('/api/sendMessage', payload);
  //     // console.log('Message sent successfully:', response.data);

  //     // Optionally clear the payload values after sending
  //     setPayloadValues({});
  //   } catch (error) {
  //     console.error('Error sending message:', error);
  //   }
  // };

  // const handleSendMessage = async () => {
  //   if (!selectedTemplate) {
  //     console.error('No template selected.');
  //     return;
  //   }
  //   const template = templates.find(t => t._id === selectedTemplate?._id);
  //   if (!template?.components?.[0]?.text) {
  //     console.error('Template has no text.');
  //     return;
  //   }
  //   try {
  //     const finalPayloadValues = { ...payloadValues };
  //     if (!finalPayloadValues[1]) {
  //       finalPayloadValues[1] = currentName;
  //     }

  //     const messageData = {
  //       messaging_product: "whatsapp",
  //       to: whatsappIds,
  //       type: "template",
  //       template: {
  //         name: template.templateName,
  //         language: {
  //           code: "en_US",
  //         },
  //         components: [
  //           {
  //             type: "body",
  //             parameters: Object.keys(finalPayloadValues).map((key) => ({
  //               type: "text",
  //               text: finalPayloadValues[key],
  //             })),
  //           },
  //         ],
  //       },
  //     };

  //     console.log('Message Data:', messageData);
  //     await dispatch(sendWpMessage(messageData));
  //     setNewMessage("");
  //     setShow4(false);
  //     setPayloadValues({});
  //   } catch (error) {
  //     console.error('Error sending message:', error);
  //   }
  // };

  // const handleSendMessage = async () => {
  //   if (!selectedTemplate) {
  //     console.error('No template selected.');
  //     return;
  //   }

  //   const template = templates.find(t => t._id === selectedTemplate?._id);
  //   if (!template?.components?.[0]?.text) {
  //     console.error('Template has no text.');
  //     return;
  //   }

  //   try {
  //     // Extract placeholders from the template text
  //     const placeholders = template.components[0].text.match(/{{\d+}}/g);

  //     // Prepare the base messageData payload
  //     let messageData = {
  //       messaging_product: "whatsapp",
  //       to: whatsappIds,
  //       type: "template",
  //       template: {
  //         name: template.templateName,
  //         language: {
  //           code: template.languageCode,
  //         },
  //       },
  //     };

  //     if (placeholders) {
  //       const finalPayloadValues = { ...payloadValues };
  //       if (!finalPayloadValues[1]) {
  //         finalPayloadValues[1] = currentName;
  //       }

  //       messageData.template.components = [
  //         {
  //           type: "body",
  //           parameters: placeholders.map((placeholder) => {
  //             const key = placeholder.match(/\d+/)[0];
  //             return {
  //               type: "text",
  //               text: finalPayloadValues[key] || '',
  //             };
  //           }),
  //         },
  //       ];
  //     }
  //     console.log('Message Data:', messageData);
  //     await dispatch(sendWpMessage(messageData));
  //     setNewMessage("");
  //     setPayloadValues({});
  //     setShow4(false);
  //   } catch (error) {
  //     console.error('Error sending message:', error);
  //   }
  // };

  const handleSendMessage = async () => {
    try {
      let messageData = null;
      if (isExpired) {
        if (!selectedTemplate) {
          console.error("No template selected.");
          return;
        }

        const template = templates.find((t) => t._id === selectedTemplate?._id);
        if (!template) {
          console.error("Template not found.");
          return;
        }

        const components = template.components.map((component) => {
          const placeholders = component.text?.match(/{{\d+}}/g); // Extract placeholders (e.g., {{1}}, {{2}})
          if (!placeholders) {
            return {
              type: component.type.toLowerCase(),
            };
          }

          // Map placeholders to parameter objects
          const parameters = placeholders.map((placeholder) => {
            const key = parseInt(placeholder.match(/{{(\d+)}}/)[1], 10); // Extract placeholder number
            return {
              type: "TEXT",
              text: payloadValues[key],
            };
          });

          return {
            type: component.type.toLowerCase(),
            parameters,
          };
        });

        // Prepare the payload for WhatsApp API
        messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "template",
          template: {
            name: template.templateName, // Use template name
            language: {
              code: template.languageCode,
            },
            components: components.filter(
              (comp) => comp.parameters || comp.text
            ), // Only include components with content
          },
        };
        console.log("Message Data:", messageData);
        await dispatch(sendWpMessage(messageData));

        setNewMessage("");
        setShow4(false);
        setPayloadValues({});
      } else {
        messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "text",
          text: {
            body: newMessage,
          },
        };
        await dispatch(sendWpMessage(messageData));

        setNewMessage("");
        setShow4(false);
        setPayloadValues({});
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };

  const handleSwitchChange = async (id) => {
    await dispatch(updateWpStatus(id));
    dispatch(getConversationList());
    setIsSwitchOn(isSwitchOn === "active" ? "inactive" : "active");
  };

  <FsLightbox toggler={imageController.toggler} sources={[Showimg]} />;

  const handleFileUpload = async (e) => {
    const { files } = e.target;

    console.log(files, "filesfiles");
    if (files.length === 0) return;

    const file = files[0];
    const fileType = file.type;
    console.log(file, "filefilefile");
    console.log(fileType, "fileTypefileTypefileType");

    let documentUrl;
    let publicId;

    try {
      const response = await dispatch(uploadFileToCloudinary(file));
      console.log(response, "responseresponseresponse");
      documentUrl = response.url;
      publicId = response.public_id;

      console.log(documentUrl, "documentUrldocumentUrldocumentUrl");
      console.log(publicId, "publicIdpublicIdpublicId");

      if (fileType.startsWith("image/")) {
        console.log(fileType, "fileType imagwe ");
        alert("image");
        const messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "image",
          image: {
            link: uploadedFile.url,
          },
        };
        dispatch(sendWpMessage(messageData));
      } else if (fileType.startsWith("application/")) {
        alert("document");
        const messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "document",
          document: {
            link: uploadedFile.url,
          },
        };
        dispatch(sendWpMessage(messageData));
      } else if (fileType.startsWith("video/")) {
        alert("video");
        const messageData = {
          messaging_product: "whatsapp",
          to: whatsappIds,
          type: "video",
          video: {
            link: uploadedFile.url,
          },
        };
        dispatch(sendWpMessage(messageData));
      } else {
        alert("not support");
        console.log("Unsupported file type:", fileType);
      }
      // await deleteFileFromCloudinary(publicId);
      console.log("File upload and Facebook post successful.");
    } catch (error) {
      console.error("Error uploading file or sending to Facebook:", error);
    }
  };

  const handleEmojiClick = (emojiObject) => {
    setNewMessage((prevMessage) => prevMessage + emojiObject.emoji);
  };

  const filteredChats = chats?.filter((chat) =>
    chat.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const isExpired = expireTime ? new Date() > new Date(expireTime) : false;

  return (
    <>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <aside
          className="sidebar sidebar-chat sidebar-base border-end shadow-none"
          data-sidebar="responsive"
          id="chatsidebar"
        >
          <div className="chat-search pt-4 px-4">
            <div className="d-flex align-items-center">
              <h5 className="fw-500">Chats</h5>
            </div>
            <div
              className="sidebar-toggle d-block d-xl-none"
              data-toggle="sidebar"
              data-active="true"
              onClick={minisidebar}
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.25 12.2744L19.25 12.2744"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </i>
            </div>
            <div className="chat-searchbar mt-3 pt-1 mb-4">
              <Form.Group className="form-group chat-search-data m-0">
                <input
                  type="text"
                  className="form-control round"
                  id="chat-search"
                  placeholder="Search for messages or users..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="material-symbols-outlined">search</i>
              </Form.Group>
            </div>
          </div>

          <div
            className="sidebar-body pt-0 data-scrollbar mb-5 pb-5 px-4"
            tabIndex="-1"
            style={{ overflow: "hidden", outline: "none" }}
          >
            <div
              className="scroll-content"
              style={{ transform: "translate3d(0px, 0px, 0px)" }}
            >
              <ul
                className="nav navbar-nav iq-main-menu mb-5 pb-5"
                id="sidebar-menu"
                role="tablist"
              >
                <h6 className="mb-3 pb-1">Recent Chats</h6>
                {filteredChats?.map((chat, index) => (
                  <Nav.Item
                    key={index}
                    as="li"
                    className="iq-chat-list mb-[1px]  ps-0"
                    role="presentation"
                  >
                    <Nav.Link
                      className={`d-flex gap-3 rounded-2 zoom-in ${
                        currentChatId === chat?._id ? "active" : ""
                      }`}
                      eventKey="first"
                      onClick={() => handleChatSelect(chat)}
                    >
                      <div className="position-relative">
                        <img
                          src={user1 || "defaultProfilePic.jpg"}
                          alt="User Avatar"
                          className="avatar-48 object-cover rounded-circle"
                          loading="lazy"
                        />
                      </div>
                      <div className="d-flex align-items-top w-100 iq-userlist-data">
                        <div className="d-flex flex-grow-1 flex-column">
                          <div className="d-flex align-items-center gap-1">
                            <h6 className="mb-0 iq-userlist-name font-size-14 fw-semibold text-ellipsis short-1 flex-grow-1">
                              {chat?.name || "Unknown User"}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </ul>
            </div>
          </div>
          <div className="sidebar-footer"></div>
        </aside>
        <main className="main-content">
          <div className="container-fluid content-inner p-0" id="page_layout">
            <Tab.Content id="myTabContent">
              <Tab.Pane //1
                eventKey="first"
                className="card mb-0 fade position-relative"
                id="user-content-101"
                role="tabpanel"
              >
                <div className="chat-head position-absolute top-0 w-100 z-indexs chat-nav ">
                  <header className="d-flex justify-content-between align-items-center pt-3 ps-3 pe-3 pb-3">
                    <div className="d-flex align-items-center gap-3">
                      <div className="d-block d-xl-none">
                        <button
                          className="btn btn-sm btn-primary rounded btn-icon"
                          data-toggle="sidebar"
                          data-active="true"
                          onClick={minisidebar}
                        >
                          <span className="btn-inner">
                            <svg
                              className="icon-rtl"
                              width="20px"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                              ></path>
                            </svg>
                          </span>
                        </button>
                      </div>
                      <div className="avatar chat-user-profile m-0">
                        <img
                          src={user1}
                          alt="avatar"
                          className="avatar-50 object-cover rounded-pill"
                          loading="lazy"
                        />
                        {/* <div className="iq-profile-badge bg-success"></div> */}
                      </div>
                      <div>
                        <h5 className="mb-0">{messageNavbar?.name}</h5>
                        {/* <small className="text-capitalize fw-500">Online</small> */}
                      </div>
                    </div>

                    <div className="chat-header-icons d-inline-flex ms-auto">
                      <div className="d-flex align-items-center btn btn-primary">
                        <span className="w-100">Autochat</span>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          className="me-2   d-flex align-items-center justify-content-center"
                          checked={isSwitchOn === "active" ? true : false}
                          onChange={() =>
                            handleSwitchChange(messageNavbar?._id)
                          } // Handle switch toggle
                        />
                      </div>
                      <Dropdown
                        className=" d-flex align-items-center justify-content-center"
                        as="span"
                      >
                        <Dropdown.Toggle
                          as="svg"
                          bsPrefix=" "
                          className="icon-20 nav-hide-arrow cursor-pointer pe-0"
                          id="dropdownMenuButton-09"
                          data-bs-toggle="dropdown"
                          role="menu"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10 20.6788C10 21.9595 11.0378 23 12.3113 23C13.5868 23 14.6265 21.9595 14.6265 20.6788C14.6265 19.3981 13.5868 18.3576 12.3113 18.3576C11.0378 18.3576 10 19.3981 10 20.6788ZM10 12.0005C10 13.2812 11.0378 14.3217 12.3113 14.3217C13.5868 14.3217 14.6265 13.2812 14.6265 12.0005C14.6265 10.7198 13.5868 9.67929 12.3113 9.67929C11.0378 9.67929 10 10.7198 10 12.0005ZM12.3113 5.64239C11.0378 5.64239 10 4.60192 10 3.3212C10 2.04047 11.0378 1 12.3113 1C13.5868 1 14.6265 2.04047 14.6265 3.3212C14.6265 4.60192 13.5868 5.64239 12.3113 5.64239Z"
                            fill="currentColor"
                          ></path>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="dropdown-menu-right"
                          aria-labelledby="dropdownMenuButton-09"
                        >
                          <Dropdown.Item
                            className=" d-flex align-items-center"
                            href="#"
                          >
                            <i className="material-symbols-outlined md-18 me-1">
                              push_pin
                            </i>
                            Pin to top
                          </Dropdown.Item>
                          <Dropdown.Item
                            className=" d-flex align-items-center"
                            href="#"
                          >
                            <i className="material-symbols-outlined md-18 me-1">
                              delete_outline
                            </i>
                            Delete chat
                          </Dropdown.Item>
                          <Dropdown.Item
                            className=" d-flex align-items-center"
                            href="#"
                          >
                            <i className="material-symbols-outlined md-18 me-1">
                              watch_later
                            </i>
                            Block
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </header>
                </div>

                <div className="card-body chat-body bg-body " ref={sectionRef}>
                  <div className="chat-day-title">
                    <span className="main-title">Feb 1,2021</span>
                  </div>
                  {messages?.map((msg) => {
                    const hasImage = msg.type === "image";
                    const hasDocumentUrl = msg.type === "document";
                    const hasVideo = msg.type === "video";
                    console.log(whatsappPhoneid, "{whatsappPhoneid}");
                    if (msg?.receiverId === whatsappPhoneid) {
                      return (
                        <div className="iq-message-body iq-other-user">
                          <div className="chat-profile text-center">
                            <img
                              src={user1}
                              alt="chat-user"
                              className="avatar-40 object-cover rounded-pill"
                              loading="lazy"
                            />
                            <small className="iq-chating p-0 mb-0 d-block">
                              16:34
                            </small>
                          </div>
                          <div className="iq-chat-text">
                            <div className="d-flex align-items-center justify-content-start gap-md-2">
                              <div
                                className={
                                  hasImage
                                    ? `d-flex align-items-center`
                                    : `iq-chating-content d-flex align-items-center`
                                }
                              >
                                {hasImage ? (
                                  <div>
                                    <img
                                      src={msg?.payload}
                                      alt="Image attachment"
                                      style={{
                                        maxWidth: "200px",
                                        objectFit: "cover",
                                        borderRadius: "5px",
                                      }}
                                    />
                                  </div>
                                ) : hasDocumentUrl ? (
                                  <div>
                                    <div className="bg-secondary p-2 text-white">
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleDocumentClick(msg.payload)
                                        }
                                      >
                                        <span className="me-2">
                                          <FaFile />
                                        </span>
                                        <span>
                                          {msg.docName
                                            ? msg.docName
                                            : "Download"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : hasVideo ? (
                                  <div>
                                    <iframe
                                      title="myFrame"
                                      className="rounded embed-responsive-item"
                                      src={msg?.payload}
                                      allowFullScreen
                                    ></iframe>
                                  </div>
                                ) : (
                                  <p className="mr-2 mb-0">{msg?.payload}</p>
                                )}
                              </div>
                              <Link
                                href="#"
                                className="material-symbols-outlined font-size-20 text-dark reply"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                data-bs-original-title="Reply"
                              >
                                reply
                              </Link>
                              <Dropdown
                                className="dropdown cursor-pointer more"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                data-bs-original-title="More"
                              >
                                <Dropdown.Toggle
                                  as="span"
                                  bsPrefix=" "
                                  className="lh-1"
                                  id="post-option"
                                  data-bs-toggle="dropdown"
                                >
                                  <span className="material-symbols-outlined text-dark">
                                    more_vert
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                  as="ul"
                                  className="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="post-option"
                                >
                                  {msg?.payload ? (
                                    <Dropdown.Item
                                      className=""
                                      href="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#post-modal"
                                      onClick={() => handleCopy(msg?.payload)}
                                    >
                                      <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                        content_copy
                                      </span>
                                      Copy message text
                                    </Dropdown.Item>
                                  ) : null}
                                  <Dropdown.Item
                                    className=""
                                    href="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#post-modal"
                                  >
                                    <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                      edit
                                    </span>
                                    Edit
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="iq-message-body iq-current-user">
                          <div className="chat-profile text-center">
                            <img
                              src={user1}
                              alt="chat-user"
                              className="avatar-40 object-cover rounded-pill"
                              loading="lazy"
                            />
                            <small className="iq-chating p-0 mb-0 d-block">
                              16:34
                            </small>
                          </div>
                          <div className="iq-chat-text">
                            <div className="d-flex align-items-center justify-content-end gap-1 gap-md-2">
                              <Dropdown
                                className="dropdown cursor-pointer more"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="More"
                              >
                                <Dropdown.Toggle
                                  className="lh-1"
                                  id="post-option"
                                  as="span"
                                  bsPrefix=" "
                                >
                                  <span className="material-symbols-outlined text-dark">
                                    more_vert
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                  className="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="post-option"
                                >
                                  {msg?.payload && (
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() => handleCopy(msg?.payload)}
                                    >
                                      <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                        content_copy
                                      </span>
                                      Copy message text
                                    </Dropdown.Item>
                                  )}
                                  <Dropdown.Item
                                    href="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#post-modal"
                                  >
                                    <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                      edit
                                    </span>
                                    Edit
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>

                              <div
                                className={
                                  hasImage
                                    ? "d-flex align-items-center"
                                    : "iq-chating-content d-flex align-items-center"
                                }
                              >
                                {hasImage ? (
                                  <img
                                    src={msg?.payload}
                                    alt="Image attachment"
                                    style={{
                                      maxWidth: "200px",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                    }}
                                  />
                                ) : hasDocumentUrl ? (
                                  <div className="bg-secondary p-2 text-white">
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleDocumentClick(msg.payload)
                                      }
                                    >
                                      <span className="me-2">
                                        <FaFile />
                                      </span>
                                      <span>{msg.docName || "Download"}</span>
                                    </div>
                                  </div>
                                ) : hasVideo ? (
                                  <iframe
                                    title="video-frame"
                                    className="rounded embed-responsive-item"
                                    src={msg?.payload}
                                    allowFullScreen
                                    frameBorder="0"
                                    width="320"
                                    height="240"
                                  ></iframe>
                                ) : (
                                  <p className="mr-2 mb-0">{msg?.payload}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>

                {showEmojiPicker && (
                  <div className="position-absolute left-0 emoji-box">
                    <EmojiPicker onEmojiClick={handleEmojiClick} />
                  </div>
                )}
                  {showquickreply && (
                  <div
                    className="position-absolute emoji-box"
                    style={{
                      left: "0",
                      bottom: "60px",
                      backgroundColor: "white",
                      color: "#fff",
                      width: "100%",
                      maxWidth: "350px",
                      borderRadius: "10px",
                      padding: "20px 10px",
                      boxShadow: "rgb(215 215 215 / 50%) 0px 2",
                      zIndex: 1000,
                    }}
                  >
                    <Row className="mb-2 px-2">
                      <Col>
                        <span
                          className="text-black"
                          style={{ fontSize: "1rem" }}
                        >
                          Quick Replies
                        </span>
                      </Col>
                    </Row>

                    <ListGroup variant="flush">
                      {filteredQuickReplies?.map((item, index) => (
                        <ListGroup.Item
                          key={index}
                          className="bg-transparent text-light border-0 py-2 border-bottom"
                          onClick={() => handleQuickReplies(item.payload)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <span
                                className="text-black"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {item.title}
                              </span>
                              <br />
                              <span
                                className="text-[#a7a7a7]"
                                style={{ fontSize: "0.95rem" }}
                              >
                                {item.payload || "No Title"}
                              </span>
                            </div>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                )}
                <div className="card-footer px-3 py-3 border-top rounded-0">
                  {isExpired ? (
                    <div className="d-flex align-items-center justify-content-center">
                      <Button
                        variant="primary"
                        onClick={handleShow4}
                        className="mt-1"
                      >
                        Send Message
                      </Button>
                    </div>
                  ) : (
                    <form className="d-flex align-items-center" action="#">
                      <div className="chat-attagement d-flex">
                        <Link
                          to="#"
                          className="d-flex align-items-center pe-3"
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        >
                          <svg
                            className="icon-24"
                            width="24"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_156_599)">
                              <path
                                d="M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z"
                                fill="currentcolor"
                              ></path>
                              <path
                                d="M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z"
                                fill="currentcolor"
                              ></path>
                              <path
                                d="M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z"
                                fill="currentcolor"
                              ></path>
                              <path
                                d="M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z"
                                fill="currentcolor"
                              ></path>
                            </g>
                            <defs>
                              <clipPath>
                                <rect
                                  width="24"
                                  height="24"
                                  fill="white"
                                  transform="translate(0 0.5)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </Link>
                        <Link className="d-flex align-items-center pe-3">
                          <TbFileUpload
                            style={{ fontSize: "25px" }}
                            onClick={() => onButtonClick()}
                          />
                        </Link>
                        <input
                          style={{ display: "none" }}
                          // accept=".zip,.rar"
                          ref={inputFile}
                          onChange={handleFileUpload}
                          type="file"
                        />
                      </div>
                      <input
                        type="text"
                        onChange={async (e) => {
                          const value = e.target.value;
                          setNewMessage(value);

                          if (e.target.value.startsWith("/")) {
                            setShowQuickReply(true);
                            const filterText = value.slice(1);
                            const filteredReplies =
                              filterText.length > 0
                                ? faqs?.filter((faq) =>
                                    faq?.title
                                      ?.toLowerCase()
                                      .includes(filterText.toLowerCase())
                                  )
                                : faqs;

                            setFilteredQuickReplies(filteredReplies);
                          } else {
                            setShowQuickReply(false);
                          }
                        }}
                        className="form-control me-3"
                        value={newMessage}
                        placeholder="Type your message"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // Stops the page refresh
                            handleSendMessage();
                            setNewMessage("");
                          }
                        }}
                      />
                      <button
                        type="submit"
                        className="btn btn-primary d-flex align-items-center"
                      >
                        <svg
                          className="icon-20"
                          width="18"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
                            stroke="currentcolor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <span className="d-none d-lg-block ms-1">Send</span>
                      </button>
                    </form>
                  )}
                </div>
                <div>
                  <Modal size="lg" centered show={show4} onHide={handleClose4}>
                    <Modal.Header closeButton>
                      <Modal.Title className="h5">
                        Send Message to the User
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group className="form-group">
                        <Form.Label>Message Template</Form.Label>
                        <select
                          className="form-select mb-3 shadow-none"
                          value={selectedTemplate?._id || ""}
                          onChange={handleTemplateChange}
                        >
                          {templates?.map((template) => (
                            <option key={template._id} value={template._id}>
                              {template?.templateName}
                            </option>
                          ))}
                        </select>
                      </Form.Group>

                    

                      {selectedTemplate &&
                        templates
                          .find((t) => t._id === selectedTemplate?._id)
                          ?.components?.flatMap(
                            (component, compIndex) =>
                              component.text
                                ?.match(/{{\d+}}/g)
                                ?.map((placeholder, index) => {
                                  const placeholderKey =
                                    placeholder.match(/{{(\d+)}}/)[1]; // Extract numeric key
                                  return (
                                    <Form.Group
                                      key={`${compIndex}-${index}`}
                                      className="mb-3"
                                    >
                                      <Form.Label>
                                        Parameter ({placeholder}) -{" "}
                                        {component.type}
                                      </Form.Label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={
                                          payloadValues[placeholderKey] || ""
                                        }
                                        onChange={(e) =>
                                          setPayloadValues({
                                            ...payloadValues,
                                            [placeholderKey]: e.target.value,
                                          })
                                        }
                                        placeholder={`Enter value for ${placeholder}`}
                                      />
                                    </Form.Group>
                                  );
                                }) || []
                          )}

                      <Card bg="primary" className="text-white mb-3">
                        <Card.Body>
                          <Card.Title as="h4" className="text-white">
                            {selectedTemplate
                              ? templates.find(
                                  (t) => t._id === selectedTemplate?._id
                                )?.templateName
                              : "No Message Type Selected"}
                          </Card.Title>
                          {/* <blockquote className="blockquote mb-0">
                            <p className="font-size-14">
                              {selectedTemplate
                                ? templates.find(t => t._id === selectedTemplate?._id)?.components?.[0]?.text
                                : 'No Message Type Selected'}
                            </p>
                          </blockquote> */}
                          <blockquote className="blockquote mb-0">
                            <p className="font-size-14">{getUpdatedText()}</p>
                          </blockquote>
                        </Card.Body>
                      </Card>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="primary" onClick={handleSendMessage}>
                        Send Message
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </main>
      </Tab.Container>
    </>
  );
};
export default Wpchat;
